exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host ::ng-deep .skin1 .skin-tab {\n  color: #1fadeb;\n}\n:host ::ng-deep .skin1 .ant-tabs-tab {\n  color: #666;\n  transition: color 0s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n:host ::ng-deep .skin1 .ant-tabs-tab:hover {\n  background: #eee;\n  color: #666;\n}\n:host ::ng-deep .skin1 .ant-tabs-tab-active {\n  background: #128fc5;\n  color: #fff;\n}\n:host ::ng-deep .skin1 .ant-tabs-tab-active:hover {\n  color: #fff;\n  background: #128fc5;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/style/skin1.less
// module id = ../../../../../src/app/style/skin1.less
// module chunks = main